import { aomGraphqlRequest } from 'core/utils/backend-service';
import {
    mapCustomFieldFromApiToModel,
    mapNewCustomFieldFromModeltoApi,
    mapUpdateCustomFieldFromModeltoApi,
} from './custom-field.mapper';
import { CustomField } from './custom-field.type';
import {
    createCustomField as createCustomFieldQuery,
    deleteCustomField as deleteCustomFieldQuery,
    getCustomFields,
    updateCustomField as updateCustomFieldQuery,
} from './custom-fields.queries';
export const getAllCustomFields = (): Promise<{
    result: {
        customFields: CustomField[];
    };
}> =>
    aomGraphqlRequest(getCustomFields()).then((response) => ({
        result: {
            customFields: response.data.customFields.map(mapCustomFieldFromApiToModel),
        },
    }));

export const createCustomField = (customField: CustomField): Promise<{ result: string }> =>
    aomGraphqlRequest(createCustomFieldQuery(), { customField: mapNewCustomFieldFromModeltoApi(customField) }).then(
        () => ({
            result: 'ok',
        })
    );

export const updateCustomField = (customField: CustomField): Promise<{ result: string }> =>
    aomGraphqlRequest(updateCustomFieldQuery(), {
        id: customField.id,
        name: mapUpdateCustomFieldFromModeltoApi(customField),
    }).then(() => ({
        result: 'ok',
    }));

export const deleteCustomField = (customFieldId: string): Promise<{ result: string }> =>
    aomGraphqlRequest(deleteCustomFieldQuery(), { id: customFieldId }).then(() => ({
        result: 'ok',
    }));
